import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M10 12h3.5v1.3q0 .35.3.475t.55-.125l1.95-1.95q.3-.3.3-.7t-.3-.7l-1.95-1.95q-.25-.25-.55-.125t-.3.475V10H9a.97.97 0 0 0-.712.288A.97.97 0 0 0 8 11v3q0 .425.288.713T9 15t.713-.288A.96.96 0 0 0 10 14zm2 10q-.375 0-.737-.15-.361-.15-.663-.45l-8-8q-.3-.3-.45-.663T2 12t.15-.737.45-.663l8-8q.3-.3.663-.45T12 2t.738.15.662.45l8 8q.3.3.45.663T22 12t-.15.738-.45.662l-8 8q-.3.3-.663.45T12 22m-4-6 4 4 8-8-8-8-8 8z"
    }, null, -1)
  ]))]))
}
export default { render: render }